export const gcpClusterMap: Record<string, string> = {
  '6284ebba-c75c-4752-86d5-ae24ef0db19e': 'europe-west3-001',
  '52b46bb4-78a2-42c1-9b36-f1c7ff7d42f4': 'asia-northeast1-001',
  'fd1bf913-bcfa-45b5-bfe2-397de18fc8a6': 'asia-northeast2-001',
  'a4d9ab8d-b928-426a-9384-2150e740488e': 'us-central1-001',
  'f0501006-a242-400f-a860-7523a11dedd0': 'us-central1-dev',
  '49c04b13-a29d-482b-97a1-7f565ca8f11b': 'southamerica-west1-001',
  'dd2f3f9b-0d7b-40ed-99d5-77a533fa45d5': 'us-west1-001',
  'd4e60847-ab94-41dd-a49f-a28c1fc65b84': 'us-west2-001',
  '31b3df2c-6ccf-416c-9d4d-aedd7e4e16d8': 'us-west3-001',
  '0f9ce949-10ba-4ce7-8805-d971e00fa429': 'australia-southeast1-001',
  '9e453bf6-37b6-4ec2-8a50-65fa2216db6a': 'us-west4-001',
  'b8945969-0171-4b3f-a498-271f444b7253': 'asia-east1-001',
  '1d37d819-e799-4176-995b-2a0fac3e1b8d': 'asia-east2-001',
  '6af530c1-02a3-4df1-9dcd-b580f15dc7b6': 'australia-southeast1-002',
  '2009fa2d-06d8-4241-b0f0-d50a17ca5dee': 'asia-northeast3-001',
  'e464b11e-7e78-4772-86cb-835d13930fb2': 'asia-south1-001',
  'd3202d41-3b46-4efc-9252-df6ce5a3dbf2': 'asia-south2-001',
  '15a98e38-57a6-461c-9cc7-e291b710a0ec': 'asia-southeast1-001',
  '27a8d78e-6621-47f1-b5c6-85e415b4dcbd': 'europe-north1-001',
  'e0b4361b-c7d1-4003-ad9c-e4bb988440ad': 'europe-west6-001',
  '81aa8dc6-e59f-44d2-99cd-f651c3208778': 'northamerica-northeast1-001',
  'fe772831-e381-4beb-bca9-d98d21e4b009': 'southamerica-east1-001',
  '20204189-9832-46a5-b281-c3dc18dbe2a4': 'europe-west1-001',
  'caaff189-e444-4c23-9c8f-446f73d74d99': 'europe-west2-001',
  'ce7757a8-594e-476c-8426-bb7abf890bee': 'europe-west3-002',
  '18668995-acee-4167-8ed7-a1b054654d01': 'europe-west4-001',
  'c434c22e-7baf-47f2-8185-cb2c522c7712': 'us-central1-002',
  'bb05b418-6c71-4a2e-824b-5fad4d88af07': 'us-east1-001',
  '56b12815-78f4-4eeb-83e8-c22b13ae7e49': 'us-east4-001',
}
